import { render, staticRenderFns } from "./OtherPurchase.vue?vue&type=template&id=5065341d&"
import script from "./OtherPurchase.vue?vue&type=script&lang=js&"
export * from "./OtherPurchase.vue?vue&type=script&lang=js&"
import style0 from "./OtherPurchase.vue?vue&type=style&index=0&id=5065341d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports